import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { NhostProvider } from '@nhost/react';
import { NhostApolloProvider } from '@nhost/react-apollo';
import { InMemoryCache } from '@apollo/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { nhost } from './lib/nhost';
import theme from './theme';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import ResetPassword from './components/ResetPassword';
import SignIn from './components/SignIn';
import ProtectedSignUp from './components/ProtectedSignUp';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import CaptainTermsAndConditions from './components/CaptainTermsAndConditions';
import CaptainPrivacyPolicy from './components/CaptainPrivacyPolicy';

import LandingPage from './pages/Landing';
import NotFoundPage from './pages/NotFound';
import MenuPage from './pages/Menu';
import OrderPage from './pages/Order';
import OrderDetailsPage from './pages/OrderDetailsPage';
import FoodPage from './pages/Food';
import AdminDashboardPage from './pages/AdminDashboard';
import EditRestaurantPage from './pages/EditRestaurant';
import CategoriesPage from './pages/CategoriesPage';
import TranscationPage from './pages/TranscationPage';
import RestaurantSettlementPage from './pages/RestaurantSettlementPage';
import AddNewRestaurantPage from './pages/AddNewRestaurantPage';
import RestaurantPage from './pages/RestaurantPage';
import EditSellerRestaurantPage from './pages/EditSellerRestaurantPage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import CarrierPage from './pages/CarrierPage';
import EditCarrierPage from './pages/EditCarrierPage';
import AddNewCarrierPage from './pages/AddNewCarrierPage';
// import OffersPage from './pages/OffersPage';

function App() {
  return (
    <NhostProvider nhost={nhost}>
      <NhostApolloProvider cache={new InMemoryCache()} nhost={nhost}>
        <ChakraProvider theme={theme}>
          <ColorModeScript initialColorMode={theme.config.initialColorMode} />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/sign-up" element={<ProtectedSignUp />} />
              <Route path="sign-in" element={<SignIn />} />
              <Route path="reset-password" element={<ResetPassword />} />
              <Route path="terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="captain-terms-and-conditions" element={<CaptainTermsAndConditions />} />
              <Route path="captain-privacy-policy" element={<CaptainPrivacyPolicy />} />
              <Route path="*" element={<NotFoundPage />} />

              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="admin" element={<AdminDashboardPage />} />
                <Route path="admin/edit-restaurant/:id" element={<EditRestaurantPage />} />
                <Route path="admin/new-restaurant" element={<AddNewRestaurantPage />} />
                <Route path="categories" element={<CategoriesPage />} />
                {/* <Route path="overview" element={<OverviewPage />} /> */}
                <Route path="restaurant" element={<RestaurantPage />} />
                <Route path="restaurant/edit" element={<EditSellerRestaurantPage />} />
                <Route path="menu" element={<MenuPage />} />
                <Route path="order" element={<OrderPage />} />
                <Route path="history" element={<OrderHistoryPage />} />
                <Route path="order/:orderId" element={<OrderDetailsPage />} />
                <Route path="transcation" element={<TranscationPage />} />
                <Route path="transcation/:id" element={<RestaurantSettlementPage />} />
                <Route path="carrier" element={<CarrierPage />} />
                <Route path="carrier/edit/:id" element={<EditCarrierPage />} />
                <Route path="carrier/new" element={<AddNewCarrierPage />} />
                {/* <Route path="profile" element={<ProfilePage />} /> */}
                <Route path="food" element={<FoodPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </ChakraProvider>
      </NhostApolloProvider>
    </NhostProvider>
  );
}

export default App;
